import { useSettings, useStyles } from '@wix/tpa-settings/react';
import settingsParams, {
  DisplayContent,
  ItemAppearance,
  LayoutType,
  OpenQuestionIcon,
  Spacing,
} from '../components/FaqOoi/settingsParams';
import { ISettingsContextValue } from '@wix/tpa-settings';
import stylesParams, {
  convertItemAppearanceStyleToItemAppearance,
} from '../components/FaqOoi/stylesParams';
import { PresetSettings } from '../types/designTypes';
import { CategoriesPosition, ItemAppearanceStyle } from '../enums';
import { presetToLayoutMap } from './presetToLayoutMap';
import constants from '../constants';

export const useLayoutType = (isEditor3: boolean) => {
  const settings: ISettingsContextValue = useSettings();
  const styles = useStyles();
  let layout: LayoutType =
    settings.get(settingsParams.layout) ?? LayoutType.Collapse;
  let categoriesPosition: CategoriesPosition =
    settings.get(settingsParams.categoriesPosition) ?? CategoriesPosition.TOP;
  let itemAppearance: ItemAppearance =
    settings.get(settingsParams.itemAppearance) ?? ItemAppearance.BOX;
  let displayContent: DisplayContent =
    settings.get(settingsParams.displayContent) ??
    constants.DISPLAY_CONTENT.SPLIT_INTO_CATEGORIES;
  const openQuestionIcon: OpenQuestionIcon =
    settings.get(settingsParams.openQuestionIcon) ?? OpenQuestionIcon.ARROW;
  let { gap, betweencols, vertical, horizontal }: Spacing = settings.get(
    settingsParams.spacing,
  ) ?? {
    gap: 12,
    betweencols: 12,
    vertical: 32,
    horizontal: 32,
  };

  if (isEditor3) {
    const presetSettings =
      (styles.get?.(stylesParams.presetSettings) as PresetSettings) ??
      PresetSettings.ACCORDION_TOP_CATEGORIES;
    const mappedPreset = presetToLayoutMap[presetSettings];
    layout = mappedPreset.layout ?? LayoutType.Collapse;
    categoriesPosition =
      mappedPreset.categoriesPosition ?? CategoriesPosition.TOP;
    displayContent =
      styles.get(stylesParams.showFAQCategories) ??
      constants.DISPLAY_CONTENT.SPLIT_INTO_CATEGORIES;
    if (displayContent === true) {
      displayContent = constants.DISPLAY_CONTENT.SPLIT_INTO_CATEGORIES;
    }
    const itemAppearanceStyle =
      styles.get(stylesParams.itemAppearanceStyle) ?? ItemAppearanceStyle.BOX;
    itemAppearance = convertItemAppearanceStyleToItemAppearance(
      itemAppearanceStyle,
    ) as ItemAppearance;
    gap = styles.get(stylesParams.spacingGap) ?? gap;

    vertical = styles.get(stylesParams.spacingVertical) ?? vertical;
    horizontal = styles.get(stylesParams.spacingHorizontal) ?? horizontal;
  }
  const numberLayout = layout === LayoutType.Stripes;
  const accordionLayout = layout === LayoutType.Collapse;
  const listLayout = layout === LayoutType.Basic;

  return {
    layout: { numberLayout, accordionLayout, listLayout, layoutValue: layout },
    categoriesPosition,
    itemAppearance,
    displayContent,
    openQuestionIcon,
    spacing: { gap, betweencols, vertical, horizontal },
  };
};
